import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiMenuAlt3, HiShoppingCart } from 'react-icons/hi';
import happy_hvid from '../images/happy-hvid.png';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleNav = () => {
    setNav(!nav);
  };
  const navigate = useNavigate();

  return (
    <div className='absolute w-full flex justify-between p-4 items-center'>
      {/* <h1 className='text-white font-bold text-2xl z-20' style={{ visibility: 'hidden' }}>Happy outdoors</h1> */}
      <img alt='happy-hvid-logo' className="z-20" src={happy_hvid} onClick={() => navigate('/')} style={{height: '60px', cursor: 'pointer'}}/>
      <div className='flex items-center gap-4'>
        <HiShoppingCart onClick={() => navigate('/basket')} className='z-20 text-white cursor-pointer' size={25} />
        <HiMenuAlt3 onClick={handleNav} className='z-20 text-white cursor-pointer' size={25} />
      </div>
      <div
        className={`ease-in duration-300 top-0 h-screen z-10 w-full ${
          nav
            ? 'fixed left-0 bg-black/90 flex-col text-gray-300'
            : 'absolute left-[-100%]'
        }`}
      >
        <ul className='flex flex-col fixed w-full h-full items-center justify-center'>
          <li className='font-bold text-3xl p-8 navbar-link'>
            <a href='/'>Home</a>
          </li>
          <li className='font-bold text-3xl p-8 navbar-link'>
            <a href='/shop'>Shop</a>
          </li>
          <li className='font-bold text-3xl p-8 navbar-link'>
            <a href="/basket">Basket</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
